<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>Take Off Your Shoes</h1>
<h1 class="bk1">One Man’s Journey from the Boardroom to Bali and Back</h1>
<h1 class="bk2"><img alt="" height="100" src="images/rbg-feder-mask.jpg" width="114"/></h1>
<p class="bkau">Ben Feder</p>
<p class="bkpub">Radius Book Group</p>
<p class="bkpub1">New York</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// rbgfeder0003.vue?d7399e84